import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'lenis/dist/lenis.css';
import './styles.css';
import './styles/home.css';
import './styles/home-overview.css';
import './styles/four-fronts.css';
import './styles/profile.css';
import './styles/area-pages.css';
import './styles/transparency.css';
import './styles/avatar.css';
import './styles/mobile-refinements.css';

const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
